import { TFunction } from 'react-i18next';
import { SummaryTableRows } from '@chargify/custom-ui-components';
import { formatCurrency } from '@chargify/formatters';
import { AllocationsPreview } from '../../../machines';

type Params = {
  allocationsPreview: AllocationsPreview;
  t: TFunction<'subscriptions-manager'[]>;
  language: string;
};

export const mapChargeSummaryToTable = ({
  allocationsPreview,
  t,
  language,
}: Params) => {
  const formatAmount = (amount: number) =>
    formatCurrency(allocationsPreview.currency, amount, language);
  const chargesSummary = [
    [
      {
        value: t('components_allocations.subtotal'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: formatAmount(allocationsPreview.subtotalInCents),
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ],
    [
      {
        value: t('components_allocations.existing_balance'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: formatAmount(allocationsPreview.existingBalanceInCents),
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ],
  ];

  if (allocationsPreview.totalDiscountInCents) {
    chargesSummary.push([
      {
        value: t('components_allocations.discounts'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: formatAmount(allocationsPreview.totalDiscountInCents),
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ]);
  }
  chargesSummary.push([
    {
      value: t('components_allocations.taxes'),
      fontWeight: 3,
      fontSize: 1,
    },
    {
      value: formatAmount(allocationsPreview.totalTaxInCents),
      fontWeight: 3,
      fontSize: 1,
      textAlign: 'right',
    },
  ]);
  return chargesSummary as SummaryTableRows;
};
